"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractShow = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../../app");
const contract_1 = require("../../../model/contract");
const payment_1 = require("../../../model/payment");
const auth_1 = require("../../../utils/auth");
const confirm_1 = require("../../../utils/confirm");
const helpers_1 = require("../../../utils/helpers");
const form_for_1 = require("../../../widgets/form_for");
const right_panel_1 = require("../../../widgets/right_panel");
const tabs_1 = require("../../../widgets/tabs");
const invoice_print_1 = require("../invoice/invoice_print");
const payment_form_1 = require("../payment/payment_form");
const payment_scheme_form_1 = require("../payment/payment_scheme_form");
const payment_table_1 = require("../payment/payment_table");
const contract_print_1 = require("./contract_print");
const edit_contract_form_1 = require("./edit_contract_form");
exports.ContractShow = {
    contract: {},
    fetched: false,
    currentTab: "infos",
    oncreate(vnode) {
        let id = vnode.attrs.id;
        this.fetch(id);
    },
    fetch(id) {
        this.contract = {};
        this.fetched = false;
        contract_1.ContractProvider.show(id).then((contract) => {
            this.contract = contract;
            this.fetched = true;
            mithril_1.default.redraw();
        });
    },
    renderTabs() {
        if (this.fetched) {
            return (0, mithril_1.default)(tabs_1.Tabs, {
                selected: this.currentTab,
                ontabchange: (pane) => { this.currentTab = pane; },
                class: "is-centered"
            }, this.renderInfos(), this.renderBookings(), this.renderPayments());
        }
        return undefined;
    },
    renderInfos() {
        var _a;
        let prop = {};
        prop = Object.assign(prop, {
            "Client": (0, helpers_1.tag)(right_panel_1.RightPanel.linkTo(this.contract.client.name, "clients", this.contract.client.id, "show")),
            "Offre": (0, helpers_1.tag)(right_panel_1.RightPanel.linkTo(this.contract.offer.name, "commercial_offers", this.contract.offer.id, "show")),
            "Numéro de facture": (0, helpers_1.tag)(((_a = this.contract.invoice) === null || _a === void 0 ? void 0 : _a.reference) || "Pas de facture"),
            "Actif": (0, helpers_1.boolProperty)(this.contract.active),
            "Créé le": (0, helpers_1.tag)((0, helpers_1.formatTime)(this.contract.created_at)),
            "Expire le": (0, helpers_1.tag)((0, helpers_1.formatTime)(this.contract.expires_at)),
            "Valeur": (0, helpers_1.tag)((0, helpers_1.moneyToString)((0, helpers_1.moneyAdd)(this.contract.value, this.contract.vat))),
            "Heures totales": (0, helpers_1.minutesToUnit)(this.contract.initial_minutes),
        });
        if (this.contract.active) {
            prop = Object.assign(prop, {
                "Heures restantes": (0, helpers_1.minutesToUnit)(this.contract.remaining_minutes),
                "Heures quota libre restantes": (0, helpers_1.minutesToUnit)(this.contract.remaining_cancelable_free_minutes),
            });
        }
        else {
            prop = Object.assign(prop, {
                "Heures perdues": (0, helpers_1.minutesToUnit)(this.contract.remaining_minutes),
                "Quota libre non consommé": (0, helpers_1.minutesToUnit)(this.contract.remaining_cancelable_free_minutes),
            });
        }
        return (0, mithril_1.default)("div", { class: "content", key: "infos", dataLabel: (0, mithril_1.default)("span", (0, helpers_1.iconSpan)("fa-star"), (0, mithril_1.default)("span", "Infos")) }, (0, helpers_1.renderProperties)(prop));
    },
    renderPayments() {
        const renderPaymentLines = () => {
            let out = [];
            this.contract.payments.sort((a, b) => {
                return a.due_at > b.due_at ? 1 : -1;
            }).forEach((p) => {
                out.push((0, mithril_1.default)("tr", (0, mithril_1.default)("td", (0, helpers_1.tag)((0, helpers_1.formatTime)(p.due_at))), (0, mithril_1.default)("td", p.paid_at ? (0, helpers_1.tag)(`OUI, Le ${(0, helpers_1.formatTime)(p.paid_at, false)}`, "success") : (0, helpers_1.tag)("NON", "danger")), (0, mithril_1.default)("td", (0, payment_1.paymentTypeToString)(p.payment_type)), (0, mithril_1.default)("td", (0, helpers_1.moneyToString)(p.value)), (0, mithril_1.default)("td", (0, mithril_1.default)("button.button.is-primary", { onclick: (evt) => { evt.preventDefault(); payment_form_1.PaymentForm.show(p); } }, (0, helpers_1.iconSpan)("fa-pen"), (0, mithril_1.default)("span", "Editer")))));
            });
            return out;
        };
        return (0, mithril_1.default)("div", { class: "content", key: "paiements", dataLabel: (0, mithril_1.default)("span", (0, helpers_1.iconSpan)("fa-money-check-alt"), (0, mithril_1.default)("span", "Paiements")) }, (0, mithril_1.default)("button.button.is-warning", {
            onclick: (evt) => {
                evt.preventDefault();
                payment_scheme_form_1.PaymentSchemeForm.show(this.contract);
            }
        }, (0, helpers_1.iconSpan)("fa-pen"), (0, mithril_1.default)("span", "Éditer le schema de paiement")), (0, mithril_1.default)("hr"), (0, mithril_1.default)("table.table", (0, mithril_1.default)("tr", (0, mithril_1.default)("th", "Dû le"), (0, mithril_1.default)("th", "Payé?"), (0, mithril_1.default)("th", "Type"), (0, mithril_1.default)("th", "Valeur"), (0, mithril_1.default)("th", "")), renderPaymentLines()));
    },
    renderBookings() {
        const renderStatus = {
            "ongoing": "À venir",
            "confirmed": "Confirmé",
            "canceled": "Annulé",
            "cleaned": "Nettoyé"
        };
        const renderConsumption = (b) => {
            if (b.consumed == b.total_consumed && b.free != 0) {
                return (0, helpers_1.minutesToUnit)(b.consumed);
            }
            else {
                const out = [];
                out.push(`${(0, helpers_1.minutesToUnit)(b.consumed)} C`);
                if (b.free > 0) {
                    out.push(`${(0, helpers_1.minutesToUnit)(b.free)} QG`);
                }
                let str = " (" + out.join(" + ") + ")";
                if (b.consumed != b.total_consumed) {
                    str += ", T=" + (0, helpers_1.minutesToUnit)(b.total_consumed);
                }
                return (0, mithril_1.default)("span", (0, helpers_1.minutesToUnit)(b.consumed), "*", (0, mithril_1.default)("small", str));
            }
        };
        return (0, mithril_1.default)("div", { class: "content", key: "bookings", dataLabel: (0, mithril_1.default)("span", (0, helpers_1.iconSpan)("fa-calendar-alt"), (0, mithril_1.default)("span", "Réservations")) }, (0, mithril_1.default)("table", (0, mithril_1.default)("thead", (0, mithril_1.default)("td", "ID"), (0, mithril_1.default)("td", "Date"), (0, mithril_1.default)("td", "Durée"), (0, mithril_1.default)("td", "Consommé"), (0, mithril_1.default)("td", "Statut"), (0, mithril_1.default)("td", "Valeur")), (0, helpers_1.ifAny)(this.contract.bookings, () => this.contract.bookings.map(b => (0, mithril_1.default)("tr", (0, mithril_1.default)("td", b.id), (0, mithril_1.default)("td", (0, helpers_1.tag)(right_panel_1.RightPanel.linkTo((0, helpers_1.formatTime)(b.date), "bookings", b.id, "show"))), (0, mithril_1.default)("td", (0, helpers_1.minutesToUnit)(b.duration)), (0, mithril_1.default)("td", renderConsumption(b)), (0, mithril_1.default)("td", (0, helpers_1.tag)(renderStatus[b.status])), (0, mithril_1.default)("td", (0, helpers_1.moneyToString)((0, helpers_1.moneyAdd)(b.value, b.vat))))), () => (0, mithril_1.default)("tr", (0, mithril_1.default)("td", { colspan: 6, style: "text-align: center; font-style: italic;" }, "Pas de réservations")))));
    },
    printPaymentCheckbox() {
        return (0, form_for_1.checkbox)("Paiement reçu?", "payment_received", this.contract, {
            oninput: (evt) => {
                evt.preventDefault();
                evt.stopPropagation();
                app_1.App.get(`/contracts/${this.contract.id}/toggle_payment_received`).then((data) => {
                    this.contract.payment_received = data.active;
                    payment_table_1.PaymentsTable.fetch();
                    mithril_1.default.redraw();
                });
            }
        });
    },
    printDeleteButton() {
        return (0, helpers_1.ifTrue)(auth_1.Auth.isAdminOnly(), (0, mithril_1.default)("a.button.is-danger", {
            onclick: () => {
                confirm_1.Confirm.confirm("Cette opération est irréversible. Toute trace du forfait disparaitra. Toutes les réservations à venir du client seront supprimées. Etes-vous sûr?").then(() => {
                    app_1.App.delete(`/contracts/${this.contract.id}`).then(() => { right_panel_1.RightPanel.close(); });
                });
            }
        }, (0, helpers_1.iconSpan)("fa-times"), (0, mithril_1.default)("span", "Supprimer")));
    },
    printSendEmailAgainButton() {
        return (0, helpers_1.ifTrue)(auth_1.Auth.isAdminOnly(), (0, mithril_1.default)("a.button", {
            onclick: () => {
                confirm_1.Confirm.confirm("Renvoyer email de fin de période ?").then(() => {
                    app_1.App.post(`/contracts/${this.contract.id}/send_email_expire_soon`).then(() => { alert("Email renvoyé!"); });
                });
            }
        }, (0, helpers_1.iconSpan)("fa-paper-plane"), (0, mithril_1.default)("span", "Renvoyer email de fin de période")));
    },
    view(_vnode) {
        return (0, mithril_1.default)("div", (0, mithril_1.default)("div", { class: "content" }, (0, helpers_1.ifTrue)(this.contract.id, (0, mithril_1.default)("h3", `Forfait #${this.contract.id}`))), (0, mithril_1.default)("div", { class: "content" }, (0, helpers_1.buttons)((0, mithril_1.default)("a.button.is-primary", { class: "button is-primary",
            onclick: () => { edit_contract_form_1.EditContractForm.show(Object.assign({}, this.contract)); }
        }, (0, helpers_1.iconSpan)("fa-pen"), (0, mithril_1.default)("span", "Editer")), this.contract.invoice ? (0, mithril_1.default)("a.button.is-info", { href: invoice_print_1.InvoicePrint.link(this.contract.invoice.id), target: "_blank" }, "Facture") : undefined, (0, mithril_1.default)("a.button.is-info", { href: contract_print_1.ContractPrint.link(this.contract.id), target: "_blank" }, "Contrat"), this.printDeleteButton(), this.printSendEmailAgainButton()), this.printPaymentCheckbox()), this.renderTabs());
    }
};
